import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { classes } from './utils';

const TabPanel = (props) => {
  const { children, value, index, isVertical, ...other } = props;
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      className={isVertical && classes.widthVeticalCOmponent}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: isVertical ? 0 : 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  isVertical: PropTypes.bool.isRequired,
};

export default TabPanel;
